/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { Shipment } from "./Shipment";
import {
  ShipmentFromJSON,
  ShipmentFromJSONTyped,
  ShipmentToJSON,
  ShipmentToJSONTyped,
} from "./Shipment";

/**
 *
 * @export
 * @interface CompanyShipment
 */
export interface CompanyShipment {
  /**
   *
   * @type {Shipment}
   * @memberof CompanyShipment
   */
  shipment: Shipment;
  /**
   *
   * @type {Company}
   * @memberof CompanyShipment
   */
  company: Company;
  /**
   *
   * @type {boolean}
   * @memberof CompanyShipment
   */
  hasScannedBol?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CompanyShipment
   */
  hasProofOfDelivery?: boolean | null;
}

/**
 * Check if a given object implements the CompanyShipment interface.
 */
export function instanceOfCompanyShipment(
  value: object,
): value is CompanyShipment {
  if (!("shipment" in value) || value["shipment"] === undefined) return false;
  if (!("company" in value) || value["company"] === undefined) return false;
  return true;
}

export function CompanyShipmentFromJSON(json: any): CompanyShipment {
  return CompanyShipmentFromJSONTyped(json, false);
}

export function CompanyShipmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyShipment {
  if (json == null) {
    return json;
  }
  return {
    shipment: ShipmentFromJSON(json["shipment"]),
    company: CompanyFromJSON(json["company"]),
    hasScannedBol:
      json["hasScannedBol"] == null ? undefined : json["hasScannedBol"],
    hasProofOfDelivery:
      json["hasProofOfDelivery"] == null
        ? undefined
        : json["hasProofOfDelivery"],
  };
}

export function CompanyShipmentToJSON(json: any): CompanyShipment {
  return CompanyShipmentToJSONTyped(json, false);
}

export function CompanyShipmentToJSONTyped(
  value?: CompanyShipment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipment: ShipmentToJSON(value["shipment"]),
    company: CompanyToJSON(value["company"]),
    hasScannedBol: value["hasScannedBol"],
    hasProofOfDelivery: value["hasProofOfDelivery"],
  };
}
